import { useMutation } from '@tanstack/react-query';

import { PluginEquifaxIdMatrixRequest } from '../../../../types/plugins';
import { handleError, handleSuccess } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { runEquifaxIdMatrixRequest } from '../../requests/runEquifaxIdMatrixRequest';

export const useRunEquifaxIdMatrixRequest = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (data: PluginEquifaxIdMatrixRequest) =>
      runEquifaxIdMatrixRequest(constructPost, data),
    onSuccess: () => handleSuccess('Equifax request completed'),
    onError: () => handleError('Equifax request failed'),
  });
  return { runEquifaxIdMatrixRequest: mutateAsync, ...rest };
};
